import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types"; 
import defaultUser from "../../assets/images/Default_user_image.png";
import { SearchOutlined } from "@mui/icons-material";
import avt from "../../assets/images/user/avatar/image-01.jpg";
import { Link, NavLink } from "react-router-dom"; 
import axios from "../.././API/axios";

const GobalSearch = () => {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [searchUser, setSearchUser] = useState([]);
  const [searchComp, setSearchComp] = useState([]);
  const [searchJob, setSearchJob] = useState([]);
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [searchPost, setSearchPost] = useState([]);
  const dropdownRef1 = useRef(null);

  console.log("inputValue", inputValue);

  const addOptions = () => { 
    axios
      .get(`/Feature/GlobalSearch?search=${inputValue}`)
      .then((response) => {
        // console.log("Response======>", response);
        let data = response.data.data;
        // console.log("Original Data:", data);

        // Process the data to extract the type and followers count
        data = data.map((item) => {
          const [type, followers] = item.type.split(",");
          return {
            ...item,
            type,
            followers: parseInt(followers, 10),
          };
        });

        console.log("Processed Data:", data);

        const addUniqueItems = (data, type) => {
          const uniqueItems = data.filter((item) => item.type === type);
          return uniqueItems;
        };

        // Clear the previous results and set the new data
        setSearchUser(addUniqueItems(data, "User"));
        setSearchComp(addUniqueItems(data, "Company"));
        setSearchJob(addUniqueItems(data, "Job"));
        setSearchPost(addUniqueItems(data, "Post"));

        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        setOptions((prev) => {
          const postSet = new Set(prev.map((post) => post.id));
          const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
          return [...prev, ...uniqueNewPosts];
        });
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };

  useEffect(() => { 

    if (inputValue) {
      addOptions(page);
    } else {
      setOptions([]);
      setSearchUser([]);
      setSearchComp([]);
      setSearchJob([]);
      setSearchPost([]);
    }
  }, [inputValue, page]);

  return (
    <>
      {/* <div className="form-group-1 khojSearch d-flex align-items-center"> */}
      <div className="search-container">
        {/* <div className="search-icon"> */}
        <SearchOutlined className="searchIcon" />
        {/* </div> */}

        <div className="search-input-container">
          <input
            type="text"
            className="input-filter-search"
            placeholder="Search"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
          />
          {(options.length > 0 || inputValue !== "") && (
            <ul className="suggestions-dropdown" ref={dropdownRef1}>
              {searchUser.length > 0 && (
                <div style={{ margin: "4px 16px" }}>
                  <p style={{ margin: "0", fontWeight: "800" }}>People</p>
                </div>
              )}
              {searchUser.map((item, index) => (
                <Link to={`/User/${item?.entityID}`} key={index}>
                  <li
                    className="suggestion-item d-flex align-center"
                    onClick={() => {
                      setOptions([]);
                      setInputValue("");
                    }}
                  >
                    <img
                      src={item?.image}
                      alt=""
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                    />
                    <div>
                      <p className="ms-2">{item?.title}</p>
                      <p className="ms-2 f-12 mb-0">{item?.additionalInfo}</p>
                      {/* <p className="ms-2 f-12">{item?.description}</p> */}
                      <p className="ms-2 f-12 mb-0">{item?.followers} followers</p>
                    </div>
                  </li>
                </Link>
              ))}
              {searchComp.length > 0 && (
                <div style={{ margin: "4px 16px" }}>
                  <p style={{ margin: "0", fontWeight: "800" }}>Company</p>
                </div>
              )}
              {searchComp.map((item, index) => (
                <Link to={`/Companydetails/${item?.entityID}`} key={index}>
                  <li
                    className="suggestion-item d-flex align-center"
                    onClick={() => {
                      setOptions([]);
                      setInputValue("");
                    }}
                  >
                    <img
                      src={item?.image}
                      alt="" 
                      style={{ borderRadius: "50%", height:"60px" }}
                    />
                    <div>
                      <p className="ms-2 mb-0">{item?.title}</p>
                      <p className="ms-2 f-12 mb-0">{item?.additionalInfo}</p>
                      {/* <p className=" f-12">{item?.description}</p> */}
                      <p className=" f-12 mb-0">{item?.followers} followers</p>
                    </div>
                  </li>
                </Link>
              ))}
              {searchJob.length > 0 && (
                <div style={{ margin: "4px 16px" }}>
                  <p
                    style={{
                      margin: "0",
                      fontWeight: "600",
                      fontSize: "20px",
                    }}
                    className="d-flex"
                  >
                    Job
                  </p>
                </div>
              )}
              {searchJob.map((item, index) => (
                <Link to={`/JobDetails/${item?.entityID}`} key={index}>
                  <li
                    className="suggestion-item d-flex align-center"
                    onClick={() => {
                      setOptions([]);
                      setInputValue("");
                    }}
                  >
                    <div className="search-user-img">
                      <img
                        // src={item?.image}
                        src={item.image}
                        alt=""
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                      />
                    </div>

                    <div>
                      <p className="ms-2 mb-0">{item?.title}</p>
                      <p className="ms-2 f-12  mb-0">{item?.additionalInfo}</p>
                      <p className="ms-2 f-12 mb-0">{item?.followers}</p>
                      {/* <p className="ms-2 f-12">
                                  {item?.followers} followers
                                </p> */}
                    </div>
                  </li>
                </Link>
              ))}
              {searchPost.length > 0 && (
                <div style={{ margin: "4px 16px" }}>
                  <p style={{ margin: "0", fontWeight: "800" }}>Post</p>
                </div>
              )}
              {searchPost.map((item, index) => (
                <Link to={`/Post/${item?.id}`} key={index}>
                  <li
                    className="suggestion-item d-flex align-center"
                    onClick={() => {
                      setOptions([]);
                      setInputValue("");
                    }}
                  >
                    <img
                      src={item?.image}
                      alt=""
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                    />
                    <div>
                      <p className="ms-2">{item?.title}</p>
                      <p className="ms-2 f-12 mb-0">{item?.additionalInfo}</p>
                      {/* <p className="ms-2 f-12">{item?.description}</p> */}
                      <p className="ms-2 f-12 mb-0">{item?.followers} followers</p>
                    </div>
                  </li>
                </Link>
              ))}
            </ul>
          )}
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default GobalSearch;
